import { createFileRoute, redirect } from '@tanstack/react-router';
import { preloadListingFixtures } from '~portal/data/fixtures';
import { isStandalone } from '~portal/lib';
import { OperatorCompanyPage } from './-company-page';

/** @desc `?brand=<slug>`: which of the group's brands the brand carousel highlights (C10, D-9). */
export type CompanySearch = { brand?: string };

export const parseCompanySearch = (raw: Record<string, unknown>): CompanySearch =>
  typeof raw.brand === 'string' && raw.brand.trim() ? { brand: raw.brand.trim() } : {};

/**
 * @desc An operator group's company page (`OperatorCompanyPage`). Brands have no page of their own
 * (client decision), so a brand link lands here with `?brand=` and the carousel marks it current.
 * Platform-only: the standalone build is the chat app alone, so it redirects to a new chat like
 * the other platform pages.
 */
export const Route = createFileRoute('/_protected/operators/$slug')({
  beforeLoad: () => {
    if (isStandalone) {
      throw redirect({ to: '/chat/$conversationId', params: { conversationId: 'new' } });
    }
  },
  // The operators and regions fixtures are lazy chunks: fetch them alongside this route's own.
  loader: preloadListingFixtures,
  validateSearch: parseCompanySearch,
  component: OperatorPage,
});

function OperatorPage() {
  const { slug } = Route.useParams();
  const { brand } = Route.useSearch();
  // Keyed by slug so moving between companies (e.g. Kindred → FDJ United) resets local state.
  return <OperatorCompanyPage key={slug} slug={slug} brandSlug={brand} />;
}
